import { render, staticRenderFns } from "./ImportGonvernmentMandatory.vue?vue&type=template&id=b0f1bf70&scoped=true"
import script from "./ImportGonvernmentMandatory.vue?vue&type=script&lang=js"
export * from "./ImportGonvernmentMandatory.vue?vue&type=script&lang=js"
import style0 from "./ImportGonvernmentMandatory.vue?vue&type=style&index=0&id=b0f1bf70&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f1bf70",
  null
  
)

export default component.exports